<div class="row">
  <div class="col-5 mb-2">
    <b>{{ name }}</b>
  </div>
  <div class="col-7">
    <ng-content *ngIf="!description"></ng-content>
    {{ description }}
  </div>
</div>
